import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "selected", "isDark", "dark", "className", "style", "onClick", "htmlProps", "children"],
  _excluded2 = ["component"];
import cn from 'classnames';
import { BUTTON } from "../Buttons/classnames";
import getDefaultIconPropValues from "../helpers/getDefaultIconPropValues";
import parseClassnames from "../helpers/parseClassnames";
import transition from "../styles/transition";
import { jsx as _jsx } from "react/jsx-runtime";
var BottomNavAction = function BottomNavAction(_ref) {
  var iconProp = _ref.icon,
    selected = _ref.selected,
    isDark = _ref.isDark,
    dark = _ref.dark,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    style = _ref.style,
    onClick = _ref.onClick,
    htmlProps = _ref.htmlProps,
    children = _ref.children,
    bottomNavActionProps = _objectWithoutProperties(_ref, _excluded);
  var iconPropIndex = selected ? 'active' : 'inactive';
  var _ref2 = iconProp && iconPropIndex in iconProp ? getDefaultIconPropValues(iconProp[iconPropIndex], 24) : getDefaultIconPropValues(iconProp, 24),
    Icon = _ref2.component,
    icon = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
    type: "button",
    className: parseClassnames(className, cn(BUTTON, {
      'border-transparent opacity-32': !selected,
      'border-white': selected && !(isDark || dark),
      'border-secondary-light': selected && (isDark || dark)
    })),
    style: _objectSpread({
      transition: transition(['opacity', 'border']),
      borderTopStyle: 'solid',
      borderTopWidth: 4,
      flexGrow: 1
    }, style),
    onClick: onClick
  }, bottomNavActionProps), htmlProps), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: cn('flex items-center justify-center w-full py-12 -mt-4', selected && (isDark || dark) ? 'text-secondary-light' : 'text-white'),
      children: Icon ? /*#__PURE__*/_jsx(Icon, {
        size: icon.size,
        className: cn({
          'fill-current': icon.hasFill,
          'stroke-current': icon.hasStroke
        }),
        ignoreColor: true
      }) : children
    })
  }));
};
export default BottomNavAction;